module.exports = "<app-dashboard-sidebar></app-dashboard-sidebar>\n<app-dashboard-people-list type=\"archives\"></app-dashboard-people-list>\n"